var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiehuan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: "200px",
    height: "200.00px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.177 422.436h937.651c24.515 0 36.531-29.855 18.816-46.848L732.278 119.875c-17.234-16.507-45.993-4.25-45.993 19.66v146.97a27.146 27.146 0 0 1-27.193 27.187H43.177A27.146 27.146 0 0 0 15.99 340.88v54.375a27.218 27.218 0 0 0 27.187 27.182z m937.646 179.128H43.177c-24.515 0-36.531 29.855-18.81 46.843l267.36 255.713c17.234 16.507 45.998 4.245 45.998-19.666v-146.97a27.141 27.141 0 0 1 27.188-27.181h616.043a27.146 27.146 0 0 0 27.182-27.193v-54.369c-0.128-14.92-12.262-27.177-27.315-27.177z",
    fill: "#3078f6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiehuan);
export default __webpack_public_path__ + "static/media/qiehuan.d19b51a8f0f9455ba39aab5b2e55cdb2.svg";
export { ForwardRef as ReactComponent };